import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.embed.agent');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-embed-agent',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.embed.agent/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 0;
}`],
})
export class PageEmbedAgentComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }
    public async ngOnInit() { await this.service.init(); await this.service.render(); }
}

export default PageEmbedAgentComponent;